module.exports = __webpack_public_path__ + "img/data_tool_fr.ed974c1f.svg";